import { getPushStatus } from './restPush';

/**
 * Pre-prompt notifiche, proposto al primo timer di recupero della vita
 * dell'utente. "Non ora" significa "più avanti", non "mai più": viene
 * riproposto UNA sola volta, ad almeno 7 giorni di distanza; dopo la
 * seconda proposta non ricompare mai più in automatico (resta il toggle
 * nel Profilo come via permanente).
 */
const KEY = 'coachfit_push_preprompt';
const MAX_PROMPTS = 2;
const REPROMPT_AFTER_MS = 7 * 24 * 60 * 60 * 1000; // 7 giorni

const readState = () => {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return { count: 0, lastShownAt: 0 };
    const parsed = JSON.parse(raw);
    if (typeof parsed?.count === 'number') {
      return { count: parsed.count, lastShownAt: Number(parsed.lastShownAt) || 0 };
    }
    // Valore inatteso/legacy: trattato come "già proposto abbastanza"
    return { count: MAX_PROMPTS, lastShownAt: 0 };
  } catch (e) {
    return null; // storage inaccessibile
  }
};

export const shouldShowPushPrePrompt = () => {
  const state = readState();
  // Storage inaccessibile: meglio non proporre nulla che riproporre a ogni timer
  if (state === null) return false;
  if (state.count >= MAX_PROMPTS) return false;
  if (state.count > 0 && Date.now() - state.lastShownAt < REPROMPT_AFTER_MS) return false;

  const status = getPushStatus();
  // 'off' → possiamo chiedere il permesso; 'need-install' → spieghiamo che
  // serve la PWA installata (iOS). Mai per granted/enabled, denied, unsupported.
  return status === 'off' || status === 'need-install';
};

export const markPushPrePromptDone = () => {
  try {
    const state = readState() || { count: 0, lastShownAt: 0 };
    localStorage.setItem(
      KEY,
      JSON.stringify({ count: state.count + 1, lastShownAt: Date.now() })
    );
  } catch (e) { /* ignore */ }
};
